export default __webpack_public_path__ + "static/logo-d-0d188b706ffc6f2f9fcb19d8e63e37c7.svg";